import Vue from "vue"
import VueRouter from "vue-router"
import layout from "@/components/layout"

// import routerView from "@/pages/routerView"
import notFound from "@/pages/404.vue"
import home from "@/pages/home/index.vue"
import obras from "@/pages/obras/index.vue"
import sobre from "@/pages/sobre/index.vue"
import contacto from "@/pages/contacto/index.vue"
import DepartamentoAdministracion from "@/pages/contacto/DepartamentoAdministracion.vue"
import SergioMartin from "@/pages/contacto/SergioMartin.vue"
import PabloRamos from "@/pages/contacto/PabloRamos.vue"
import ElenaHernandez from "@/pages/contacto/ElenaHernandez.vue"
import CarlosMunoz from "@/pages/contacto/CarlosMunoz.vue"
import InamaculadaBenito from "@/pages/contacto/InmaculadaBenito.vue"
import TomasRavicule from "@/pages/contacto/TomasRavicule.vue"
import DavidMorales from "@/pages/contacto/DavidMorales.vue"
import DavidPacheco from "@/pages/contacto/DavidPacheco.vue"
import aviso from "@/pages/aviso/index.vue"
import cookies from "@/pages/cookies/index.vue"
import privacidad from "@/pages/privacidad/index.vue"

 
Vue.use(VueRouter)
const routes = [
  {
    path: "/",
    name: "layout", 
    redirect: "/home",
    component: layout,
    children: [
      {
        path: "/home",
        name: "home",
        component: home,
        meta: {
          title: "Home",
          theme: "black" 
        },
      },
      { 
        path: "/obras",
        name: "Obras",
        component: obras,
        meta: {
          title: "Obras",
          theme: "black"
        },
      },
      {
        path: "/sobre",
        name: "Sobre Nosotros",
        component: sobre,
        meta: {
          title: "Sobre Nosotros",
          theme: "black"
        },
      },
      {
        path: "/contacto",
        name: "Contacto",
        component: contacto,  
        meta: {
          title: "Contacto",
          theme: "black"
        },
      },   
      {
        path: "/DepartamentoAdministracion",
        name: "DepartamentoAdministracion",
        component: DepartamentoAdministracion,  
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/SergioMartin",
        name: "SergioMartin",
        component: SergioMartin,  
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/PabloRamos",
        name: "PabloRamos",
        component: PabloRamos,  
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/ElenaHernandez",
        name: "ElenaHernandez",
        component: ElenaHernandez,  
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/CarlosMunoz",
        name: "CarlosMunoz",
        component: CarlosMunoz,  
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/InmaculadaBenito",
        name: "InmcualdaBenito",
        component: InamaculadaBenito,  
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/TomasRavicule",
        name: "TomasRavicule",
        component: TomasRavicule,
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/DavidMorales",
        name: "DavidMorales",
        component: DavidMorales,
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/DavidPacheco",
        name: "DavidPacheco",
        component: DavidPacheco,
        meta: {
          isHide: true,
          title: "card",
          theme: "black"
        },
      },
      {
        path: "/aviso", 
        name: "aviso",
        component: aviso,  
        meta: {
          isHide: true,
          title: "Aviso",
          theme: "black"
        },
      },{
        path: "/cookies", 
        name: "cookies",
        component: cookies,  
        meta: {
          isHide: true,
          title: "cookies",
          theme: "black"
        },
      },{
        path: "/privacidad", 
        name: "privacidad",
        component: privacidad,  
        meta: {
          isHide: true,
          title: "privacidad",
          theme: "black"
        },
      },
      
    ],    
  }, 

  {
    path: "*",
    name: "layout",
    component: layout,
    children: [
      {
        path: "*",
        name: "404", 
        component: notFound,
        meta: {
          isHide: true,
          title: "暂无页面",
          icon: "el-icon-notebook-2",
        },
      },
    ],
  },
]
const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})
export default router
